import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import ProcessosEncerradosCard from './components/ProcessosEncerradosCard';
import PageHeader from '@spark/ui-components/components/BreadCrumb';

const VagasProcessoEncerradosMain = () => {
  return <Container fluid>
      <Row>
        <Col md={12}>
          <PageHeader title="" routeSegments={[{
          name: 'Início'
        }, {
          name: 'Processos Encerrados',
        }]} />
        </Col>
      </Row>
      
      <Row>
        <Col md={12}>
          <ProcessosEncerradosCard />
        </Col>
      </Row>
    </Container>;
};

export default VagasProcessoEncerradosMain;
